import { abbreviateNumber } from "helpers";
import { SocialIcon } from "modules/sharing";
import { useTranslation } from "react-i18next";

import { SocialItemProps } from "../SocialSources.types";

import styles from "../SocialSources.module.scss";

export const SocialItem = ({ social, title, amount }: SocialItemProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles["sources__socials--item"]}>
      <div className={styles["sources__socials--item-icon"]}>
        <SocialIcon social={social} size={30} />
      </div>
      <p className={styles["sources__socials--item-name"]}>{title}</p>
      <p className={styles["sources__socials--item-count"]}>
        {abbreviateNumber(amount, 1)} {t("shares")}
      </p>
    </div>
  );
};
